import WorkflowInstance from '../OnPremWorkflowInstance';
import OnPremSiteToSiteVPNConfiguration from './OnPremSiteToSiteVPNConfiguration';
import { PortOpeningRequestsDirection } from '../enums/POR/PortOpeningRequestsDirection';
import OnPremSiteToSiteVPNStandardConfiguration from './OnPremSiteToSiteVPNStandardConfiguration';
import User from '../User';

export default class OnPremSiteToSiteVPNRequest {

	id!: number;

	direction!: PortOpeningRequestsDirection;

	type!: string;

	companyName!: string;

	trackerID!: number;

	approver!: User;

	workID!: number;

	onPremWorkflowInstance!: WorkflowInstance;

	exxonMobilConfiguration!: OnPremSiteToSiteVPNConfiguration;

	externalConfiguration!: OnPremSiteToSiteVPNConfiguration;

	standardConfiguration!: OnPremSiteToSiteVPNStandardConfiguration;

	exxonEncrypDomain!: string;

	externalEncrypDomain!: string;

	conDeviceCount!: string;

	changeTicketId?: string;

	constructor(obj: any) {
		Object.assign(this, obj);
		this.direction = new PortOpeningRequestsDirection().fromValue(obj.direction?.value);
	}
}